import { ActionTypes } from "../constantes/ActionTypes";

const initialState = {
  data: [],
  isLoading: false,
  error: "",
};

export const ShipmentRefreshReducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case ActionTypes.ACTION_SHIPMENT_REFRESH_START:
      return {
        ...state,
        isLoading: true,
      };
    case ActionTypes.ACTION_SHIPMENT_REFRESH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: payload,
      };
    case ActionTypes.ACTION_SHIPMENT_REFRESH_FAILED:
      return {
        ...state,
        isLoading: false,
        error: payload,
      };
    default:
      return state;
  }
};
